import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const ScrollStyled = styled(Flexer.Child)`
  overflow: hidden;
  overflow-y: auto;
`;

export default ScrollStyled;
